
import { mapState, mapActions } from "vuex";
import smsOtp from "~/assets/images/smsOtp.svg";
import emailOtp from "~/assets/images/emailOtp.svg";
import backButtonFullHeight from "./back-button-full-height.vue";
export default {
  components: { backButtonFullHeight },
  name: "OtpVerificationEmailMobile",
  data() {
    return {
      smsOtp,
      emailOtp,
      otp: "",
      formError: "",
      valid: true,
      otpTimer: 0,
      resendOtpTimer: 0,
      otpIntervalID: "",
      otpResendIntervalID: "",
      otpRules: [
        (v) => !!v || "OTP is required",
        (v) => /\d{6}/.test(v) || "Sorry! Invalid OTP"
      ]
    };
  },
  props: {
    signupData: {
      type: Object,
      default: () => {}
    },
    resetDataProp: {
      type: Object,
      default: () => {}
    },
    isEmailOtp: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    resetTimer: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.startOtpTimer();
    if (this.isSignup && !this.signupData?.name) {
      this.resendOtp();
    }
  },
  watch: {
    resetTimer(val) {
      if (val) {
        this.startOtpResendTimer();
      }
    }
  },
  computed: {
    isSignup() {
      return !!this.signupData;
    },
    otpChannel() {
      if (this.isSignup) {
        if (this.isEmailOtp) {
          return this.signupData?.email;
        } else {
          return (
            this.signupData?.mobile.country_code +
            this.signupData?.mobile.number
          );
        }
      } else {
        if (this.isEmailOtp) {
          return this.resetDataProp?.otpRequest?.email;
        } else {
          return this.resetDataProp?.otpRequest?.mobile_number;
        }
      }
    }
  },
  methods: {
    ...mapActions("auth", [
      "verifySignupEmailOtp",
      "requestSignupMobileOtp",
      "requestSignupEmailOtp",
      "login",
      "requestForgotPasswordpOtp",
      "verifyForgotPasswordOtp"
    ]),
    startOtpTimer() {
      clearInterval(this.otpIntervalID);
      this.otpTimer = 15 * 60;
      this.otpIntervalID = setInterval(this.decreaseOtpTimer, 1000);
    },
    decreaseOtpTimer() {
      this.otpTimer--;
      if (this.otpTimer == 0) {
        clearInterval(this.otpResendIntervalID);
      }
    },
    startOtpResendTimer() {
      this.startOtpTimer();
      clearInterval(this.otpResendIntervalID);
      this.resendOtpTimer = 2 * 60;
      this.otpResendIntervalID = setInterval(this.decreaseOtpResendTimer, 1000);
    },
    decreaseOtpResendTimer() {
      this.resendOtpTimer--;
      if (this.resendOtpTimer == 0) {
        clearInterval(this.otpResendIntervalID);
      }
    },
    validateForm() {
      this.valid = this.$refs.formOtp.validate();
    },
    submitOtp() {
      if (this.valid) {
        this.$emit("submit-otp", this.otp);
      }
    },
    resendOtp() {
      this.$emit("resend-otp");
    }
  }
};
